import React, { useEffect, useState } from "react";
import { transformResultsToTableData } from "../../../../services/commonService";
import InsightTable from "../InsightTable";

function HeadquartersAndBusinessSegments({
  headquartersAndBusinessSegmentData,
}) {
  const [tabData, setTabData] = useState([]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    {
      type: "conversation",
      title: "Conversation",
      onClick: () => {},
    },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  // const dummyData = [
  //   {
  //     competitor: "a",
  //     hq_location: "b",
  //     business_segments: "c",
  //     hq_location_positive_insight: "b",
  //     hq_location_negative_insight: "b",
  //     hq_location_recent_development: "b",
  //     business_segments_positive_insight: "c",
  //     business_segments_negative_insight: "c",
  //     business_segments_recent_development: "c",
  //   },
  //   {
  //     competitor: "d",
  //     hq_location: "e",
  //     business_segments: "f",
  //     hq_location_positive_insight: "b",
  //     hq_location_negative_insight: "b",
  //     hq_location_recent_development: "b",
  //     business_segments_positive_insight: "c",
  //     business_segments_negative_insight: "c",
  //     business_segments_recent_development: "c",
  //   },
  // ];

  useEffect(() => {
    const transformed = transformResultsToTableData(
      headquartersAndBusinessSegmentData
    );
    setTabData(transformed);
  }, [headquartersAndBusinessSegmentData]);

  const tableColumns = [
    { key: "hq_location", label: "HQ Location" },
    { key: "business_segments", label: "Business Segments" },
  ];

  return (
    <InsightTable
      title="Headquarters & Business Segments"
      data={tabData}
      metrics={tableColumns}
      rowIdentifier="competitor"
      actions={actions}
    />
  );
}

export default HeadquartersAndBusinessSegments;
